// eslint-disable-next-line func-names
export default function () {
    /**
     * Get input value
     * @param nameId
     * @param dataType
     * @param aboveZero
     * @returns {boolean|number|*}
     */
    function getInputValue(nameId, dataType = 'string', aboveZero = false) {
        let item = document.getElementById(nameId);

        if (item === null || item.value === undefined || item.value === '' || item.value === 'false') {
            return false;
        }

        if (dataType === 'number') {
            let number = parseInt(item.value, 10);

            if (aboveZero && number < 1) {
                return false;
            }

            return number;
        }

        return item.value;
    }

    /**
     * Get data url string
     * @param list
     * @returns {string}
     */
    function getDataString(list = {}) {
        let dataString = '';

        for (const [key, value] of Object.entries(list)) {
            if (value !== false) {
                dataString += `&${key}=${value}`;
            }
        }

        return dataString;
    }

    let route = getInputValue('route');

    if (route !== 'common/home') {
        const productId = getInputValue('_product_id', 'number', true);
        // const articleId = getInputValue('_article_id', 'number', true);
        // const recordId = getInputValue('_record_id', 'number', true);

        const dataString = getDataString({
            rt: route,
            path: getInputValue('_path'),
            parent: getInputValue('_parent'),
            product_id: productId,
            // article_id: articleId,
            // record_id: recordId,
            // filter_ocfilter: getInputValue('_filter_ocfilter'),
            // request_uri: getInputValue('_request_uri'),
        });

        $.ajax({
            url: 'index.php?route=content/hide_blocks',
            dataType: 'json',
            data: dataString,
            async: false,
            success(data) {
                const {submenu, mobileMenu, footer, whyBuy} = data;

                $('#megamenu-ajax').html(submenu);
                $('#vertical-menu').html(mobileMenu);
                $('#footer').html(footer);

                if (whyBuy) {
                    $('#why-buy').html(whyBuy);
                }

                $(document).foundation();
            },
        });
    }
}
